import { render, staticRenderFns } from "./ManageAccount.vue?vue&type=template&id=5ff1b095&scoped=true"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"
import style0 from "./ManageAccount.vue?vue&type=style&index=0&id=5ff1b095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1b095",
  null
  
)

export default component.exports